import React from "react";
import { nodeViewProps } from "@/types/extension-types";
import { classNamePrefix } from "@/utils/common";
import cn from "classnames";

const AttachmentView: React.FC<nodeViewProps> = (props) => {
  const { attrs, provider } = props;
  const { name, size, src } = attrs;

  const doCopy = () => {
    provider && provider.copy(src);
  };

  const doDownload = () => {
    provider && provider.download(src, name);
  };

  return (
    <div
      className={cn(classNamePrefix("attachment"), {
        "align-right": attrs?.align === "right",
      })}
      spellCheck={false}
      contentEditable={false}
    >
      <div className="attachment-icon" />
      <div className="content">
        <div className="name">{name}</div>
        <div className="size">{size}</div>
      </div>
      <div className="copy" onClick={doCopy}>
        <div className="btn-copy" />
      </div>
      <div className="download" onClick={doDownload}>
        <div className="btn-download" />
      </div>
    </div>
  );
};

export default AttachmentView;
